import { Shield, User } from 'lucide-react';

export const SETTINGS_NAV_ITEMS = [
	{ label: 'Profile', href: '/settings/profile', icon: User },
	{ label: 'Account', href: '/settings/account', icon: Shield },
];
